<template>
    <entity-list
        entity="lammie"
        :use-events="true"
        api-name="lammieRequests"
        :event-id="eventId"
        :team-id="teamId"
    ></entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
export default {
    name: 'LammieList',
    components: {
        'entity-list': EntityList,
    },
    props: {
        eventId: {
            type: [String, Number],
            required: false,
        },
        teamId: {
            type: [String, Number],
            required: false,
        },
    },
}
</script>
